/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpsertBusinessMemorySettingsRequestBody,
  UpsertBusinessMemorySettingsRequestBody$Outbound,
  UpsertBusinessMemorySettingsRequestBody$outboundSchema,
} from "../components/upsertbusinessmemorysettingsrequestbody.js";

export type UpsertBusinessMemoryAnalysisSettingsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpsertBusinessMemoryAnalysisSettingsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  upsertBusinessMemorySettingsRequestBody:
    UpsertBusinessMemorySettingsRequestBody;
};

/** @internal */
export type UpsertBusinessMemoryAnalysisSettingsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpsertBusinessMemoryAnalysisSettingsSecurity$outboundSchema:
  z.ZodMiniType<
    UpsertBusinessMemoryAnalysisSettingsSecurity$Outbound,
    UpsertBusinessMemoryAnalysisSettingsSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function upsertBusinessMemoryAnalysisSettingsSecurityToJSON(
  upsertBusinessMemoryAnalysisSettingsSecurity:
    UpsertBusinessMemoryAnalysisSettingsSecurity,
): string {
  return JSON.stringify(
    UpsertBusinessMemoryAnalysisSettingsSecurity$outboundSchema.parse(
      upsertBusinessMemoryAnalysisSettingsSecurity,
    ),
  );
}

/** @internal */
export type UpsertBusinessMemoryAnalysisSettingsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpsertBusinessMemorySettingsRequestBody:
    UpsertBusinessMemorySettingsRequestBody$Outbound;
};

/** @internal */
export const UpsertBusinessMemoryAnalysisSettingsRequest$outboundSchema:
  z.ZodMiniType<
    UpsertBusinessMemoryAnalysisSettingsRequest$Outbound,
    UpsertBusinessMemoryAnalysisSettingsRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      upsertBusinessMemorySettingsRequestBody:
        UpsertBusinessMemorySettingsRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        upsertBusinessMemorySettingsRequestBody:
          "UpsertBusinessMemorySettingsRequestBody",
      });
    }),
  );

export function upsertBusinessMemoryAnalysisSettingsRequestToJSON(
  upsertBusinessMemoryAnalysisSettingsRequest:
    UpsertBusinessMemoryAnalysisSettingsRequest,
): string {
  return JSON.stringify(
    UpsertBusinessMemoryAnalysisSettingsRequest$outboundSchema.parse(
      upsertBusinessMemoryAnalysisSettingsRequest,
    ),
  );
}
